import MegaMenu from './born-megamenu';
import {breakpoints, setOverlay, unsetOverlay, allowScrollableAreas, toggleInert, publishEvent, headerEl, initModules} from '../helpers/utilities';
import {loadOnDemandImage} from '../helpers/imageUtilities';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import {default as setupSearch, closeSearch} from './search';
import setupHeaderFocus from './headerFocusManager';
import {updatePuck} from './puckSizer';
import {subscribe} from '../helpers/pubSub';
import {appendParamsToURL} from '../helpers/urlUtilities';
import * as progress from './progress';
import BornModal from '@borngroup/born-modal';
import {objectAssign} from '@borngroup/born-utilities';
import * as validation from './customValidation';

/**
 * Displays an overlay if the current viewport is larger than `breakpoints.small`.
 * @param  {[type]} set [description]
 * @return {[type]}     [description]
 */
function _toggleOverlay(set) {
    if (set) {
        setOverlay({trigger: 'megamenu'});
    } else if (window.innerWidth > breakpoints.small) {
        unsetOverlay({trigger: 'megamenu'});
    }
}

function _checkIsLevel1(triggerEl) {
    return triggerEl.getAttribute('data-nav-component') === 'anchor-1';
}

function setupMobileFlyoutTrigger() {
    let triggerEl = document.querySelector('[data-nav-component="trigger"]');

    if (triggerEl && triggerEl.toggle) {
        triggerEl.toggle.afterSet = function() {
            toggleInert('.main, .footer', true);

            disableBodyScroll(triggerEl.toggle.targetEl, {allowTouchMove: allowScrollableAreas});
        };

        triggerEl.toggle.afterUnset = function() {
            toggleInert('.main, .footer');
            enableBodyScroll(triggerEl.toggle.targetEl);
        };
    }
}

/**
 * Returns the first flyout tab that has a configured subnavigation.
 * @return {HTMLElement} a flyout anchor matching the `[data-nav-tab="anchor-2"]` attribute.
 */
function _getFirstTabMatch(triggerEl) {
    let tabAnchors = triggerEl.megamenu.target.querySelectorAll('[data-nav-tab="anchor-2"]'),
        firstTabMatch = null;

    for (let i = 0; i <= tabAnchors.length; i++) {
        if (tabAnchors[i] && tabAnchors[i].megamenu && tabAnchors[i].megamenu.children) {
            firstTabMatch = tabAnchors[i];

            break;
        }
    }

    return firstTabMatch;
}

/**
 * Sets up flyout states when opening up the top-level item, and when toggling between tabs.
 */
function _updateFlyoutState(triggerEl, megaMenu) {
    let firstTabMatch = _getFirstTabMatch(triggerEl);

    if (firstTabMatch) {
        megaMenu.toggleTriggerActive(firstTabMatch);

        updatePuck(firstTabMatch, true);
    } else if (triggerEl.matches('[data-nav-tab]')) {
        updatePuck(triggerEl);

        loadOnDemandImage(triggerEl.megamenu.target);
    }
}

/**
 * Initializes Megamenu functionality.
 * @return {[Class]} [description]
 */
function setupMegamenu() {
    return new MegaMenu({
        menuSelector: '.header-flyout',
        targetSelector: '.header-flyout__container',
        matchingSiblingsAttribute: 'data-nav-component',
        unsetSiblingsSelector: '.no--submenu',
        responsive: [
            {
                breakpoint: `(min-width: ${breakpoints.small + breakpoints.unit}px)`,
                settings: {
                    events: [
                        {
                            selector: '.level-1',
                            events: 'touchstart mouseenter keydown'
                        },
                        {
                            selector: ':not(.level-1)',
                            events: 'touchstart mouseenter keydown'
                        }
                    ],
                    hoverDelay: 150,
                    unsetOnMouseleave: true,
                    triggerSelector: '[data-nav-component*="anchor"]',
                    clickThroughSelector: '[data-nav-component="anchor-3"]',
                    disableUnsetSelf: '[data-nav-tab="anchor-2"]',
                    customAttributes: function(triggerEl) {
                        let isLevel1 = _checkIsLevel1(triggerEl);

                        return {
                            'aria-controls': isLevel1 ? {value: triggerEl.megamenu.target.id, trigger: true} : false,
                            'aria-expanded': isLevel1 ? {value: [ 'false', 'true' ], trigger: true} : false
                        };
                    },
                    afterMenuSet: function() {
                        _toggleOverlay(true);
                        document.querySelectorAll('html')[0].classList.add('blockScroll');
                        document.querySelectorAll('html')[0].style.marginRight = '15px';

                        //Ensure scroll direction is set when the menu opens to prevent the navigation from going away once the user focuses out of it.
                        if (headerEl.classList.contains('fixit--scrolled')) {
                            publishEvent('fixit', 'updateScrollDirection', headerEl, {scrollDirection: 'up'});
                        }
                    },
                    afterMenuUnset: function() {
                        _toggleOverlay(false);
                        document.querySelectorAll('html')[0].classList.remove('blockScroll');
                        document.querySelectorAll('html')[0].style.marginRight = '0';
                    },
                    afterTriggerSet: function(triggerEl, megaMenu) {
                        closeSearch();

                        _updateFlyoutState(triggerEl, megaMenu);
                    },
                }
            },
            {
                breakpoint: `(max-width: ${breakpoints.small}px)`,
                settings: {
                    events: 'click keydown',
                    triggerSelector: '[data-nav-component*="anchor"], .header-flyout__secondary-link',
                    keyboardNavigation: {
                        horizontal: false,
                        vertical: '[data-nav-component*="anchor"], .header-flyout__anchor--parent'
                    },
                    afterTriggerSet: function(triggerEl) {
                        if (!triggerEl.matches('[data-nav-tab]')) {
                            toggleInert(triggerEl.megamenu.siblings, true);
                        } else {
                            loadOnDemandImage(triggerEl.megamenu.target);
                        }
                    },
                    afterTriggerUnset: triggerEl => toggleInert(triggerEl.megamenu.siblings)
                }
            }
        ]
    });
}

function loginFormError() {
    subscribe('loginForm:error', function(data) {
        var notificationElem = document.querySelector('.mi-cust-notify');

        if (notificationElem) {
            if (data.response.migratedCustomer) {
                notificationElem.classList.add('set--visible');
            } else {
                notificationElem.classList.remove('set--visible');
            }
        }
    });
}

function sliderMegaMenu(container) {
    var scrollDuration = 200;
    var leftArrow = $(container).find('.header-flyout__left-arrow');
    var rightArrow = $(container).find('.header-flyout__right-arrow');
    // get items dimensions
    let menuItem = $(container).find('.header-flyout__tab-list').children('.header-flyout__tab-item');
    //var itemsLength = menuItem.length;
    let itemWidth = 0;
    $.each(menuItem, function(i, value) {
        itemWidth = value.offsetWidth + itemWidth;
    });
    var paddleMargin = 20;

    // get wrapper width
    var getMenuWrapperSize = function() {
        return $('.header-flyout__list--sections').outerWidth();
    }
    var menuWrapperSize = getMenuWrapperSize();

    window.addEventListener('resize', function() {
        menuWrapperSize = getMenuWrapperSize();
    });
    // get total width of all menu items
    var getMenuSize = function() {
        return itemWidth;
    };
    var menuSize = getMenuSize();
    // get how much of menu is invisible
    var menuInvisibleSize = menuSize - menuWrapperSize;

    // get how much have we scrolled to the left
    var getMenuPosition = function() {
        return $(container).find('.header-flyout__tab-list').scrollLeft();
    };

    // finally, what happens when we are actually scrolling the menu
    $(container).find('.header-flyout__tab-list').on('scroll', function() {
        // get how much of menu is invisible
        menuInvisibleSize = menuSize - menuWrapperSize;
        // get how much have we scrolled so far
        var menuPosition = Math.abs(getMenuPosition());

        var menuEndOffset = menuInvisibleSize - paddleMargin;

        if (menuPosition <= paddleMargin) {
            leftArrow.addClass('hidden');
            rightArrow.removeClass('hidden');
        } else if (menuPosition < menuEndOffset) {
            // show both paddles in the middle
            leftArrow.removeClass('hidden');
            rightArrow.removeClass('hidden');
        } else if (menuPosition >= menuEndOffset) {
            leftArrow.removeClass('hidden');
            rightArrow.addClass('hidden');
        }

    });

    if (menuWrapperSize > itemWidth && rightArrow && !$(rightArrow).hasClass('hidden')) {
        $(rightArrow).addClass('hidden');
    } else if (menuWrapperSize < itemWidth && rightArrow && $(rightArrow).hasClass('hidden')) {
        $(rightArrow).removeClass('hidden');
    }

    // scroll to left
    $(rightArrow).on('click', function() {
        if ($('html').attr('dir') == 'rtl') {
            $(container).find('.header-flyout__tab-list').animate({
                scrollLeft: getMenuPosition() - 250
            }, scrollDuration);
        } else {
            $(container).find('.header-flyout__tab-list').animate({
                scrollLeft: getMenuPosition() + 250
            }, scrollDuration);
        }
    });

    // scroll to right
    $(leftArrow).on('click', function() {
        if ($('html').attr('dir') == 'rtl') {
            $(container).find('.header-flyout__tab-list').animate({
                scrollLeft: getMenuPosition() + 250
            }, scrollDuration);
        } else {
            $(container).find('.header-flyout__tab-list').animate({
                scrollLeft: getMenuPosition() - 250
            }, scrollDuration);
        }
    });
}

let menuHandler = $('[data-nav-component="anchor-1"]');

menuHandler.on('mouseenter touchstart', function() {
    sliderMegaMenu(this.closest('.header-flyout__item'));
});

function isInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function checkAutoplay() {
    let video = document.querySelector('[data-video-component="parent"]'),
        playButton = document.querySelector('.vjs-play-control');
    if (video && isInViewport(video) && playButton && !video.classList.contains('set--video-playing')) {
        playButton.click();
    } else if (video && !isInViewport(video) && playButton && video.classList.contains('set--video-playing')) {
        playButton.click();
    }
}

[ 'load', 'resize', 'scroll' ].forEach(function(evt) {
    window.addEventListener(evt, checkAutoplay);
});

function getNewsLetterLinkText() {
    let newsLetterConfig = window.SFRA.SitePreferences.newsLetterSubscriptionConfig;
    let currentLocale = window.SFRA.Constants.LOCALE_XML_CODE;

    try {
        let newsLetterConfigJSON = newsLetterConfig ? JSON.parse(newsLetterConfig) : null;
        return newsLetterConfigJSON ? newsLetterConfigJSON[currentLocale] : '#NewsletterSubscribe';
    } catch (e) {
        return '#NewsletterSubscribe';
    }
}

function getLoginLinkText() {
    let loginTextConfig = window.SFRA.SitePreferences.loginTextConfig;
    let currentLocale = window.SFRA.Constants.LOCALE_XML_CODE;
    try {
        let loginTextConfigJSON = loginTextConfig ? JSON.parse(loginTextConfig) : null;
        return loginTextConfigJSON ? loginTextConfigJSON[currentLocale] : '#login';
    } catch (e) {
        return '#login';
    }
}
function modalOpenWithContent(paramsContent) {
    let modalContent = paramsContent.content || paramsContent.html,
        modalInstance;

    if (modalContent) {
        let originalCallback;

        paramsContent.options = objectAssign({}, paramsContent.options);
        paramsContent.tracking = objectAssign({}, paramsContent.tracking);
        paramsContent.options.content = modalContent;

        originalCallback = paramsContent.callback || paramsContent.options.afterCreateCallback;

        paramsContent.options.afterCreateCallback = function(modal) {
            if (typeof originalCallback === 'function') {
                originalCallback(modal);
            }

            initModules(modal);
            validation.init();
        };

        modalInstance = new BornModal(paramsContent.options);

        delete paramsContent.options.afterCreateCallback;

        return modalInstance;
    }
}

function dialogOpen(modalParams) {
    let targetModalContent;

    modalParams.options = modalParams.options || {};

    targetModalContent = BornModal.getModal(modalParams.options.modalID);

    //Avoid making unnecessary requests if modal was already loaded once.
    if (targetModalContent) {
        //Makes sure the afterOpenCallback is taken from the object every time, in case the values change.
        targetModalContent.modal.afterOpenCallback = modalParams.options.afterOpenCallback || function() {
            return false;
        };

        targetModalContent.modal.open();
    } else {
        if (modalParams.url) {
            progress.showLoader();

            $.ajax({
                dataType: modalParams.type || 'json',
                url: modalParams.url,
                data: modalParams.data,
                xhrFields: {
                    withCredentials: true
                }
            })
                .done(function(response) {
                    progress.hideLoader();

                    modalParams.content = typeof response === 'string' ? response : (response.renderedTemplate || response.content);

                    modalOpenWithContent(modalParams);

                })
                .fail(function(xhr, textStatus) {
                    // failed
                    if (textStatus === 'parsererror') {
                        console.log('Bad response type. Check if your `dataType` request matches the response type.');
                    }
                })
        }
    }
}

if (window.SFRA.SitePreferences.enableNewsletterSubscriptionLink) {
    document.addEventListener('DOMContentLoaded', function() {
        let isHomePage = window.location.href.indexOf('/home') >= 0 || window.location.href.indexOf('/Home-Show') >= 0;
        let newsLetterSubscriptionLinkText = getNewsLetterLinkText();
        if (isHomePage && newsLetterSubscriptionLinkText && window.location.href.indexOf(encodeURI(newsLetterSubscriptionLinkText)) >= 0) {
            let modalOptions = {
                modalClass: 'modal--base modal--newsletter',
                modalID: 'footerNewsletterSubscribe',
                overlayOthers: true
            }
            dialogOpen({
                url: appendParamsToURL(window.SFRA.Urls.newsLetterSubscribeUrl, {isModalLoadFromLink: true}),
                type: 'html',
                options: modalOptions
            })
        }
    });
}

if (window.SFRA.SitePreferences.enableLoginLink) {
    document.addEventListener('DOMContentLoaded', function() {
        let isHomePage = window.location.href.indexOf('/home') >= 0 || window.location.href.indexOf('/Home-Show') >= 0;
        let loginPageLinkText = getLoginLinkText();
        if (isHomePage && loginPageLinkText && window.location.href.indexOf(encodeURI(loginPageLinkText)) >= 0) {
            if (window.SFRA.sessionData.loggedin) {
                window.location.href = window.SFRA.Urls.accountShow;
            } else {
                let targetURL,
                    targetModalID = 'auth',
                    targetModalClass = 'modal--auth modal--base modal--flex';
                targetURL = appendParamsToURL(window.SFRA.Urls.loginShow, {
                    rurl: 1,
                    renderView: 'modal',
                    isModalLoadFromLink: true
                });
                dialogOpen({
                    url: targetURL,
                    type: 'html',
                    options: {
                        modalID: targetModalID,
                        modalClass: targetModalClass,
                        keepAlive: false,
                        overlayOthers: true
                    }
                })
            }
        }
    });
}

function setHeaderHeight() {
    let headerContainerEl = document.querySelector('[data-header-component="header-container"]'),
        headerPromo = document.querySelector('[data-header-component="promo"]'),
        headerNavEl = document.querySelector('[data-header-component="header"]'),
        experienceComponent = document.querySelectorAll('.experience-component'),
        moduleGridItem = document.querySelectorAll('.module-grid__item'),
        headerMainNav = document.querySelector('.header__main-nav'),
        headerHeight,
        headerNavHeight;
    if (headerPromo) {
        if (headerPromo.firstElementChild) {
            headerHeight = $(headerPromo).find('.promo-banner-list__item:first-child').outerHeight() + headerNavEl.clientHeight;
        } else {
            headerHeight = headerContainerEl.clientHeight;
        }
    } else {
        headerHeight = headerContainerEl.clientHeight;
    }
    headerNavHeight = $(headerMainNav).outerHeight();
    $(experienceComponent[0]).find(moduleGridItem[0]).addClass('hero-fullscreen__first-element');
    $('.hero__aspect-ratio--fullscreen').css('--header-floating-height', headerHeight + 'px');
    $('.hero__aspect-ratio--fullscreen').css('--header-fixed-height', headerNavHeight + 'px');
}

export default function() {
    setupMegamenu();
    setupSearch();
    setupMobileFlyoutTrigger();
    setupHeaderFocus();
    loginFormError();
    checkAutoplay();
    setHeaderHeight();
}
